import { Iso900114001ConfirmDialog } from "../../../components/shared/Iso900114001ConfirmDialog";

type Props = {
  open: boolean;
  title: string;
  nombre: string | null;
  deleting: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
};

export function CalidadSuministradoresDeleteModal({
  open,
  title,
  nombre,
  deleting,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Iso900114001ConfirmDialog
      open={open && nombre !== null}
      title="Eliminar registro"
      description={nombre
        ? `¿Seguro que quieres eliminar “${nombre}” de ${title}? Esta acción no se puede deshacer.`
        : ""}
      confirming={deleting}
      onClose={onClose}
      onConfirm={() => {
        void onConfirm();
      }}
    />
  );
}
